import React, { useEffect, useState, useCallback, useMemo } from "react";
import { getCourses, createBundle } from "../../../service/BundleService";
import LabelAndInputField from "../../../components/shared/new Form/Fields/LabelAndInputField";
import CustomSearchDropdown from "../../../components/shared/new Form/Fields/CustomSearchDropdown";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../components/shared/pagination/messages";
import CustomModal from "../../../components/global/CustomModal/CustomModal";
import CustomButton from "../../../components/global/Button/CustomButton";
import { useCourses } from "../../../hooks/CurriculumsHooks/useGetCourses";

const AddBundle = ({
  isModalOpen,
  getBundles,
  handleCloseModal,
  setLoading: setParentLoading,
}) => {
  const [formData, setFormData] = useState({ bundleName: "", courses: [] });
  const [formErrors, setFormErrors] = useState({});
  const [localLoading, setLocalLoading] = useState(false);

  const { courseList, fetchCourses } = useCourses();

  const validate = (data) => {
    const errors = {};
    if (!data.bundleName?.trim()) {
      errors.bundleName = "Field should not be Empty.";
    } else if (
      !/^(?!\d)(?!\s)[A-Za-z][A-Za-z0-9 ]*(?<!\s)$/.test(data.bundleName)
    ) {
      errors.bundleName = "Invalid name format.";
    }
    if (!data.courses || data.courses.length === 0) {
      errors.courses = "Please select at least one course.";
    }
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
};

const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
};

  const handleSubmit = async () => {
    const errors = validate(formData);
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      setLocalLoading(true);
      if (setParentLoading) setParentLoading(true);

      const payload = {
        bundleName: formData.bundleName.trim(),
        courses: formData.courses,
      };

      const response = await createBundle(payload);
      showSuccessMessage(
        response?.data?.message || "New Curriculum Added successfully",
      );
      getBundles();
      handleCloseModal();
    } catch (error) {
      showErrorMessage(
        error?.message || "Failed to Add new Curriculum",
      );
    } finally {
      setLocalLoading(false);
      if (setParentLoading) setParentLoading(false);
    }
  };

  const resetForm = useCallback(() => {
    setFormData({ bundleName: "", courses: [] });
    setFormErrors({});
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      fetchCourses();
      resetForm();
    }
  }, [isModalOpen]);



  return (
    <CustomModal
      title="Create Curriculum"
      visible={isModalOpen}
      onClose={handleCloseModal}
      width={500}
      footer={
        <div className="form-actions">
          <CustomButton
            onClick={handleSubmit}
            variant="primary"
            loading={localLoading}
          >
            Add Curriculum
          </CustomButton>
          <CustomButton onClick={handleCloseModal} variant="outlined">
            Cancel
          </CustomButton>
        </div>
      }
    >
      <div className="form-wrapper">
        <LabelAndInputField
          labelText="Curriculum Name"
          isCompulsary={true}
          controlId="bundleName"
          controlName="bundleName"
          placeholder="Curriculum Name"
          value={formData.bundleName}
          handleInputChange={handleInputChange}
          errorMessage={formErrors.bundleName}
        />

        <CustomSearchDropdown
          labelText="Select Courses"
          isCompulsary={true}
          controlId="courses"
          controlName="courses"
          placeholder="Select Courses"
          value={formData.courses}
          options={courseList}
          handleSelectChange={handleSelectChange}
          errorMessage={formErrors.courses}
          multiSelect={true}
          maxTagCount={1}
          listHeight={150}
        />
      </div>
    </CustomModal>
  );
};

export default AddBundle;
